export const defaultPalette = {
  id: 'T_001',
  name: 'Default theme',
  colors: {
    text: '#fff',
    primary: '#1F4258',
    secondary: '#142d3b',
    accent: '#ffffff',
    altAccent: '#142d3b',
    // ppvText: '#003330',
    // ppvBg: '#2bcec7',
    // promotionText: '#ffffff',
    // promotionBg: '#ce2b79',
    badgeLiveBg: '#e13773',
    badgeTimeBg: '#ffeb12',
    textDark: '#000',
    translucent: '#fff',
    shade: '#000',
    gradient: {
      start: '#294451',
      end: '#111D22',
    },
    videoBg: '#222',
  },
}

export const coffeePalette = {
  id: 'T_003',
  name: 'Coffee',
  colors: {
    text: '#e4bcbc',
    primary: '#b4856e',
    secondary: '#51382a',
    accent: '#fbb27f',
    translucent: '#e7ceb4',
    shade: '#000',
    gradient: {
      start: '#7f4e37',
      end: '#4d3626',
    },
    videoBg: '#222',
  },
}

export const goldTextPalette = {
  id: 'T_006',
  name: 'Gold Text',
  colors: {
    text: '#ffd700',
  },
}
